import { render, staticRenderFns } from "./ResourceGallery.vue?vue&type=template&id=8ab92ae8"
import script from "./ResourceGallery.vue?vue&type=script&lang=ts"
export * from "./ResourceGallery.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports